import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const gallerySlice = createSlice({
  name: 'gallerySliceName',
  initialState,
  reducers: {
    addGallery: (state) => {
      state.loading = true;
    },
    getGallery: (state) => {
      state.loading = true;
    },
    getOneGallery: (state) => {
      state.loading = true;
    },

    successGallery: (state, action) => {
      if (action.payload && action.payload.data && Array.isArray(action.payload.data)) {
        state.data = action.payload.data;
      } else if (action.payload && Array.isArray(action.payload)) {
        state.data = action.payload;
      } else {
        state.data = action.payload && action.payload.data ? action.payload.data : action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    removeGallery: (state) => {
      state.loading = true;
    },
    updateGallery: (state) => {
      state.loading = true;
    },
    toggleGallery: (state) => {
      state.loading = true;
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { addGallery, removeGallery, updateGallery, getGallery, successGallery, getOneGallery, toggleGallery } = gallerySlice.actions

export default gallerySlice.reducer